import React, { FC } from 'react';
import { Box } from '@mui/material';
import { PrimaryButton, StyledButtonType } from '@bigid-ui/components';

export const FormSectionButton: FC<Pick<StyledButtonType, 'onClick' | 'disabled' | 'text' | 'dataAid'>> = ({
  onClick,
  disabled,
  text,
  dataAid,
}) => (
  <>
    <Box
      sx={{
        mb: 1,
        '& button': {
          maxWidth: '100%',
        },
        display: { sm: 'none' },
      }}
    >
      <PrimaryButton
        size="large"
        width="fill"
        onClick={onClick}
        disabled={disabled}
        text={text}
        dataAid={`${dataAid}-mobile`}
      />
    </Box>
    <Box
      sx={{
        mb: 1,
        ml: 3,
        display: { xs: 'none', sm: 'block' },
        textAlign: 'left',
      }}
    >
      <PrimaryButton size="medium" onClick={onClick} disabled={disabled} text={text} dataAid={dataAid} />
    </Box>
  </>
);
